import React, { useContext } from 'react'
import { Card, Col, Row, Table } from '@themesberg/react-bootstrap'
import { TableRow } from '../component/TableRow'
import { Context } from '../EwalletAndPaymentGatewayDetail'
import Pagination from '../../../../components/Pagination';

const _Table = () => {

  const { state, dispatch } = useContext(Context);

  return (
    <>
      <Card border="light" className="shadow-sm">
        <Table responsive className="align-items-center table-bordered table-hover">
          <thead className='text-center'>
            <tr>
              <th scope="col">MÃ GD</th>
              <th scope="col">MÃ GD đối tác</th>
              <th scope="col">Ví</th>
              <th scope="col">Giá trị</th>
              <th scope="col">Phí</th>
              <th scope="col">Phí cố định</th>
              <th scope="col">Tổng tiền</th>
              <th scope="col">Ngày</th>
            </tr>
          </thead>
          <tbody>
            {state.data.list && state.data.list.map((pv, index) => <TableRow from={state.filter.from} to={state.filter.to} rIndex={index} key={`table-keys-lottmekong-${pv.method}-${pv.subMethod}`} {...pv} />)}
          </tbody>
        </Table>
        <Card.Footer className='flex-row'>
          <Row className="align-items-center">
            <Col>
              <Pagination
                totalPage={state.data.totalPage || 0}
                currentPage={state.filter.page || 0}
                onPageChange={(i) => {
                  dispatch({
                    type: 'UPDATE_PAGE',
                    payload: i
                  })
                }}
              />
            </Col>
          </Row>
        </Card.Footer>
      </Card>
    </>
  );
};

export default React.memo(_Table)